import TechPartnersHero from "./components/TechPartnersHero";
import TechPartnersWhatIs from "./components/TechPartnersWhatIs";
import TechPartnersDirectory from "./components/TechPartnersDirectory";
import TechPartnersEngagement from "./components/TechPartnersEngagement";
import TechPartnersPathwayNav from "./components/TechPartnersPathwayNav";
import TechPartnersMission from "./components/TechPartnersMission";

export default function TechPartners() {
  return (
    <main className="min-h-screen">
      <TechPartnersHero />
      <TechPartnersWhatIs />
      <TechPartnersDirectory />
      <TechPartnersEngagement />
      <TechPartnersPathwayNav />
      <TechPartnersMission />
    </main>
  );
}